import React from 'react';
import i18next from 'i18next';
import { DateFormatter } from 'components/AppTable/CellsComponents';

const formatStatus = value => {
  if (!value) {
    return '—';
  }
  const key = `trainingParts.statuses.${value}`;
  const translated = i18next.t(key);
  return translated === key ? value : translated;
};

const getTrainingPartsTableConfig = () => [
  {
    title: i18next.t('trainingModules.code'),
    field: 'code',
    isSorting: false,
  },
  {
    title: i18next.t('tablesLabels.versionCode'),
    field: 'versionCode',
    isSorting: true,
  },
  {
    title: i18next.t('tablesLabels.status'),
    field: 'status',
    isSorting: true,
    Component: formatStatus,
  },
  {
    title: i18next.t('trainingParts.complianceFrom'),
    field: 'complianceFrom',
    isSorting: true,
    Component: value => <DateFormatter value={value} format="MM/DD/YYYY" />,
  },
  {
    title: i18next.t('trainingParts.complianceTo'),
    field: 'complianceTo',
    Component: value => (value ? <DateFormatter value={value} format="MM/DD/YYYY" /> : '—'),
  },
  {
    title: i18next.t('tablesLabels.availableFrom'),
    field: 'availableFrom',
    isSorting: true,
    Component: value => <DateFormatter value={value} format="MM/DD/YYYY" />,
  },
  {
    title: i18next.t('tablesLabels.availableTo'),
    field: 'availableTo',
    Component: value => (value ? <DateFormatter value={value} format="MM/DD/YYYY" /> : '—'),
  },
  {
    title: i18next.t('tablesLabels.lastUpdate'),
    field: 'updatedAt',
    isSorting: true,
    Component: value => <DateFormatter value={value} format="MM/DD/YYYY LT" />,
  },
  {
    title: '',
    field: 'id',
    isVisible: false,
  },
  {
    title: 'hasMoodleLinkHidden',
    field: 'hasMoodleLink',
    isVisible: false,
  },
];

export default getTrainingPartsTableConfig;
